// tslint:disable: no-magic-numbers
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { filter, map, concatMap, catchError } from 'rxjs/operators';
import { Location } from '@angular/common';
import { of } from 'rxjs/observable/of';
import * as momentModule from 'moment';
import { CAST_USER_CONSTANTS } from './cast-user.constants';
import { CastUserRestService } from './rest/cast-user-rest.service';
import { CastUserSessionService } from './session/cast-user-session.service';
import { HandleErrorsCastService } from '../handle-errors/cast/handle-errors.cast.service';
import { HandleErrorsService } from '../handle-errors/main/handle-errors.service';
var CastUserService = /** @class */ (function () {
    function CastUserService(castUserRestService, castUserSessionService, cookieService, handleErrorsCastService, handleErrorsService, location, router) {
        this.castUserRestService = castUserRestService;
        this.castUserSessionService = castUserSessionService;
        this.cookieService = cookieService;
        this.handleErrorsCastService = handleErrorsCastService;
        this.handleErrorsService = handleErrorsService;
        this.location = location;
        this.router = router;
        this.moment = momentModule;
    }
    /**
     * Call CastUserRestService to ser baseUrl
     * @param options base url and error state
     */
    CastUserService.prototype.setOptions = function (options) {
        this.castUserRestService.enablePavasEndpoints(options.usePavasEndpoints);
        this.castUserRestService.setBaseUrl(options.baseUrl);
        this.options = options;
    };
    /**
     * Check if an user is currently booking a cast offer and is elegible for it,
     *  then save the response in sessionStorage
     * @param promoCode promo code to be validated
     * @param affiliation affiliation associated to the offer
     * @returns Observable that checks user eligibility for an offer
     */
    CastUserService.prototype.checkCastPromoCode = function (promoCode, affiliation) {
        var _this = this;
        var isElegible = false;
        return this.checkOfferEligibility(promoCode, affiliation)
            .pipe(concatMap(function (response) {
            if (response.cast || response.stored) {
                return _this.getCastData()
                    .pipe(map(function (castUser) {
                    if (castUser && !castUser.hireDate) {
                        throw {
                            status: CAST_USER_CONSTANTS.ERROR_STATUS.FORBIDDEN,
                            error: {
                                errorCode: CAST_USER_CONSTANTS.ERROR_CODES.MISSING_DATA
                            }
                        };
                    }
                    // if cast flag is coming it means the data is coming from service
                    // and we have to save it in session storage
                    if (response.cast) {
                        castUser.affiliation = affiliation;
                        castUser.promoCode = promoCode;
                        _this.castUserSessionService.saveCastData(castUser);
                    }
                    isElegible = true;
                    return isElegible;
                }));
            }
            _this.castUserSessionService.removeOfferData();
            return of(isElegible);
        }), catchError(function (error) {
            return _this.handleErrorsService.handleServiceError(error, {
                errorState: _this.options.errorState,
                myIdUrl: _this.options.myIdUrl
            }).pipe(map(function () { throw false; }));
        }));
    };
    /**
     * Get cast user data and save it in sessionStorage
     * @returns Observable with cast data
     */
    CastUserService.prototype.getCastData = function () {
        var _this = this;
        var castUser = this.castUserSessionService.getSessionCastData();
        var checkData = castUser && castUser.checkData;
        if (castUser && !checkData) {
            return of(castUser);
        }
        else {
            return this.castUserRestService.getCastData()
                .pipe(map(function (response) {
                if (checkData) {
                    if (_this.isSameCastUser(castUser, response)) {
                        delete castUser.checkData;
                        response = castUser;
                    }
                    else {
                        _this.castUserSessionService.saveCastData(response);
                        throw {
                            status: CAST_USER_CONSTANTS.ERROR_STATUS.FORBIDDEN,
                            error: {
                                errorCode: CAST_USER_CONSTANTS.ERROR_CODES.DATA_NOT_MATCHED
                            }
                        };
                    }
                }
                _this.castUserSessionService.saveCastData(response);
                return response;
            }));
        }
    };
    /**
     * Check if an user is elegible for an offer
     * @param promoCode promo code to be validated
     * @returns Observable that checks user eligibility for an offer
     * @param affiliation affiliation associated to the offer
     */
    CastUserService.prototype.checkOfferEligibility = function (promoCode, affiliation) {
        var castUser = this.castUserSessionService.getSessionCastData();
        if (promoCode && affiliation && affiliation.indexOf(CAST_USER_CONSTANTS.CAST_AFFILIATION_SUFFIX) >= 0) {
            if (castUser && promoCode === castUser.promoCode) {
                return of({
                    stored: true
                });
            }
            else {
                return this.castUserRestService.checkOfferEligibility(promoCode);
            }
        }
        else {
            return of({
                cast: false
            });
        }
    };
    /**
     * Determine if this is a cast user in order to add X-Disney-Internal-Is-Cast
     * @returns {boolean} returns true if the cast session data is both present and the affiliation includes _CAST
     */
    CastUserService.prototype.isCastUser = function () {
        var castUser = this.castUserSessionService.getSessionCastData();
        return !!(castUser && castUser.affiliation &&
            castUser.affiliation.endsWith(CAST_USER_CONSTANTS.CAST_AFFILIATION_SUFFIX));
    };
    /**
     * Extract and remove access token from URL to save it as a acookie
     */
    CastUserService.prototype.initProccessMyIdData = function () {
        var _this = this;
        var castUser;
        this.router.fragment.pipe(filter(function (fragment) { return fragment && fragment.indexOf(CAST_USER_CONSTANTS.CAST_COOKIE) >= 0; }), map(function (fragment) {
            var _a;
            var params = new URLSearchParams(fragment);
            return _a = {},
                _a[CAST_USER_CONSTANTS.CAST_COOKIE] = params.get(CAST_USER_CONSTANTS.CAST_COOKIE),
                _a[CAST_USER_CONSTANTS.EXPIRES_COOKIE] = params.get(CAST_USER_CONSTANTS.EXPIRES_COOKIE),
                _a;
        })).subscribe(function (params) {
            if (params[CAST_USER_CONSTANTS.CAST_COOKIE]) {
                var expirationTime = _this.moment().add(parseInt(params[CAST_USER_CONSTANTS.EXPIRES_COOKIE], 10) ||
                    CAST_USER_CONSTANTS.DEFAULT_TIME, 'seconds').toDate();
                castUser = _this.castUserSessionService.getSessionCastData();
                _this.cookieService.set(CAST_USER_CONSTANTS.CAST_COOKIE, params[CAST_USER_CONSTANTS.CAST_COOKIE], expirationTime, CAST_USER_CONSTANTS.PATH_COOKIE);
                if (castUser) {
                    castUser.checkData = true;
                    _this.castUserSessionService.saveCastData(castUser);
                }
                _this.location.replaceState(_this.location.path(false));
            }
        });
    };
    /**
     * Wrapper handle cast error to send defined options
     * @param statusCode status code
     * @param errorCode error code that defines what kind error is coming
     * @returns Observable error after error has been handled
     */
    CastUserService.prototype.handleCastErrorWrapper = function (statusCode, errorCode) {
        return this.handleErrorsCastService.handleCastError(statusCode, errorCode, {
            errorState: this.options.errorState,
            myIdUrl: this.options.myIdUrl
        }).pipe(map(function () { throw false; }));
    };
    /**
     * Check old cast data stored against the new one coming from service to check if they matched
     * @param oldData
     * @param newData
     * @returns true if both data is the same, false otherwise
     */
    CastUserService.prototype.isSameCastUser = function (oldData, newData) {
        return oldData && newData &&
            oldData.employeeNumber &&
            newData.employeeNumber &&
            oldData.employeeNumber === newData.employeeNumber;
    };
    return CastUserService;
}());
export { CastUserService };
